export default __webpack_public_path__ + "static/media/logotype-full_color.c5dbdcdc.png";